export const REVIEWS_TYPES = {
  ALL: 'ALL',
  LANDING: 'LANDING',
  MERCHANT: 'MERCHANT',
  PRODUCT: 'PRODUCT',
}
